module.exports = __webpack_public_path__ + "img/remove.493ab5fe.svg";